<div class="content">
    <div class="card">
      <div class="card-header header-elements-inline" [ngBusy]="busy">
        <h6 class="card-title">Liste des Rendez-vous</h6>
    </div>
        <div class="card-body">
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Client</th>
          <th>Banquier</th>
          <th>Date de début</th>
          <th>Date de fin</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let appointment of appointments">
          <td>{{ appointment.client?.company_name || 'N/A' }}</td>
          <td>{{ appointment.banker?.name || 'N/A' }}</td>
          <td>{{ appointment.start_time | date: 'd/M/yy, H:mm' : 'UTC' }}</td>
          <td>{{ appointment.end_time | date: 'd/M/yy, H:mm' : 'UTC' }}</td>
          <td>
            <button class="btn btn-danger btn-sm" (click)="deleteAppointment(appointment.id)">Supprimer</button>
          </td>
        </tr>
      </tbody>
    </table>
  
    <p *ngIf="appointments.length === 0">Aucun rendez-vous trouvé.</p>
  </div>
</div>
</div>
  
